import DOMPurify from 'dompurify'

// eslint-disable-next-line no-undef
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('sane-html', (el, binding) => {
    el.innerHTML = DOMPurify.sanitize(binding.value)
  })
})
